import { api } from "@/lib/api";

export async function downloadFile(path, fallbackName) {
  const r = await api.get(path, { responseType: "blob" });
  const m = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "");
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = m?.[1] || fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
